import { useEffect, useState } from 'react';

export const KAIYLEE_BUSY = 'KAIYLEE_BUSY';
export const STOCK_PHOTOS_BUSY = 'STOCK_PHOTOS_BUSY';
export const KAIYLEE_BUSY_MESSAGE = 'Kaiylee is experiencing high demand. Please try again later. Funding & payment and Contact our team are still available.';
export const STOCK_PHOTOS_BUSY_MESSAGE = 'Stock photos are experiencing high demand. Please try again later.';
const STORAGE_KEY = 'hug.service-cooldowns';
const listeners = new Set();
const deadlines = {};

export function serviceRetryAt(code) {
  try {
    const stored = Number(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')[code]);
    if (Number.isFinite(stored)) deadlines[code] = Math.max(deadlines[code] || 0, stored);
  } catch (_) {
    // In-memory cooldowns still work when browser storage is unavailable.
  }
  return deadlines[code] || 0;
}

export function resetServiceAvailability() {
  Object.keys(deadlines).forEach((code) => delete deadlines[code]);
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* Storage is optional. */ }
  listeners.forEach((listener) => listener());
}

export const isServicePaused = (code) => serviceRetryAt(code) > Date.now();

export function observeServiceAvailability(availability) {
  const code = availability?.code;
  if (![KAIYLEE_BUSY, STOCK_PHOTOS_BUSY].includes(code)) return;
  const seconds = Number(availability.retryAfterSeconds);
  const header = availability.retryAfter;
  const headerSeconds = /^\d+$/.test(String(header)) ? Number(header) : (Date.parse(header) - Date.now()) / 1000;
  const delay = Number.isFinite(seconds) && seconds > 0 ? seconds
    : Number.isFinite(headerSeconds) && headerSeconds > 0 ? headerSeconds : 60;
  const until = Date.now() + delay * 1000;
  if (!Number.isFinite(until) || until <= serviceRetryAt(code)) return;
  deadlines[code] = until;
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(deadlines)); } catch (_) { /* Storage is optional. */ }
  listeners.forEach((listener) => listener());
}

export function useServiceCooldown(code) {
  const [, redraw] = useState(0);
  const retryAt = serviceRetryAt(code);
  useEffect(() => {
    const update = () => redraw((value) => value + 1);
    listeners.add(update);
    update();
    return () => listeners.delete(update);
  }, [code]);
  useEffect(() => {
    if (retryAt <= Date.now()) return undefined;
    const timer = setTimeout(() => redraw((value) => value + 1), Math.min(retryAt - Date.now(), 2147483647));
    return () => clearTimeout(timer);
  }, [retryAt]);
  return { paused: retryAt > Date.now(), retryAt };
}
